<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ assistant.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AssistantTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CButton color="primary" @click="addOption">Добавить</CButton>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <draggable v-model="options" tag="tbody">
                                <tr v-for="option in options" :key="option.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle"
                                        />
                                    </td>
                                    <td>{{ option.title }}</td>
                                    <td>{{ option.price }}</td>
                                    <td>
                                        <CButton
                                            @click="editOption(option)"
                                        ><CIcon
                                            :content="$options.icons.cilPencil"
                                            class="handle"
                                        /></CButton>
                                        <CButton
                                            @click="removeOption(option)"
                                        ><CIcon
                                            :content="$options.icons.cilTrash"
                                            class="handle"
                                        /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save"
                    >Сохранить порядок</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <AssistantOptionUpsertDialog
            ref="upsertDialog"
            :entity="selectedOption"
            @success="fetch" />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Действительно удалить? Это действие нельзя будет отменить."
            @confirm="confirmDelete"
        />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js'
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';

    import AssistantTabLinks from '@/components/assistant/AssistantTabLinks';
    import AssistantOptionUpsertDialog from '@/components/assistant/AssistantOptionUpsertDialog';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        name: 'AssistantOptions',

        components: {
            AssistantTabLinks,
            AssistantOptionUpsertDialog,
            AppConfirmDialog,
            draggable,
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil,
        },

        data() {
            return {
                assistant: {
                    title: '',
                },
                options: [],
                selectedOption: {},
            };
        },

        computed: {},

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                Vue.axios
                    .get('/assistants/' + id)
                    .then(resp => {
                        this.assistant = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                Vue.axios
                    .get('/assistants/' + id + '/options')
                    .then(resp => {
                        this.options = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            save() {
                const optionsToSave = [];
                let index = 0;
                this.options.forEach(option => {
                    optionsToSave.push({
                        id: option.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/assistants/' + this.assistant.id + '/options/reorder', {
                        reorder: optionsToSave,
                    })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            addOption() {
                this.selectedOption = {
                    assistant_id: this.assistant.id
                };
                this.$refs.upsertDialog.open();
            },

            editOption(option) {
                this.selectedOption = option;
                this.$refs.upsertDialog.open();
            },

            removeOption(option) {
                this.selectedOption = option;
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.selectedOption.id) {
                    return false
                }

                const [error] = await to(this.axios.delete(`/assistants/${this.selectedOption.assistant_id}/options/${this.selectedOption.id}`))

                if (error) {
                    return this.$root.$emit('showError', 'ошибка при удалении. ' + error)
                }

                await this.fetch();
            },

            goBack() {
                this.$router.push({ path: '/assistants/' + this.$route.params.id });
            },
        },
    };
</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
